import { constants } from "../../../constants";

export default class RequestRefresh {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.web.requestRefresh();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.PNG:
            case constants.RST:
                event["reloadGame"] = this._default;
                break;
            case constants.EGT:
                event["com.egt-bg.reload"] = this._default;
                break;
            case constants.NEXTGEN:
            case constants.NYXNEXTGEN:
                event["reload"] = this._default;
                break;
            default:
                event["requestRefresh"] = this._default;
        }

        return event;
    }
}
